module.exports = __webpack_public_path__ + "assets/cadei-24.ecf98f9eff9b803588c140687414e267.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/cadei-24.png
 ** module id = 487
 ** module chunks = 0
 **/